import * as React from "react";
import type { SVGProps } from "react";
const SvgConfirmed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#18A09F"
      d="M78.544 65.97 74.63 20.955c-.243-2.9-2.932-5.172-6.12-5.172h-7.732v10.456c0 1.295-1.149 2.343-2.568 2.343-1.417 0-2.567-1.048-2.567-2.343V15.782h-23.62v10.456c0 1.295-1.15 2.343-2.568 2.343s-2.567-1.048-2.567-2.343V15.782h-7.733c-3.187 0-5.876 2.271-6.119 5.166L9.12 65.978c-.303 3.606 1.068 7.195 3.76 9.847C15.573 78.477 19.39 80 23.352 80h40.962c3.962 0 7.78-1.523 10.472-4.175s4.063-6.242 3.758-9.854M55.4 43.047 42.12 55.164a2.7 2.7 0 0 1-1.816.687c-.657 0-1.314-.23-1.816-.687l-6.223-5.68c-1.003-.915-1.003-2.397 0-3.313 1.003-.915 2.63-.915 3.63 0l4.41 4.023L51.77 39.732c1.001-.914 2.627-.914 3.63 0 1.003.915 1.003 2.399 0 3.314M43.833 0c-9.344 0-16.945 6.938-16.945 15.465v.317h5.135v-.317c0-5.943 5.297-10.78 11.81-10.78s11.81 4.837 11.81 10.78v.317h5.135v-.317C60.778 6.938 53.177 0 43.833 0"
    />
  </svg>
);
export default SvgConfirmed;
